// v3.4.062 — «الدعوات» صفحة مستقلة في القائمة الجانبية
// كانت تابًا داخل «التواصل المؤسسي»؛ فُصلت لأنها مسار عمل قائم بذاته
// (تصميم + مستلمون + إرسال) لا علاقة له بلوحة رسائل واتساب الأعمال.
import React from "react";
import { FiImage } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import InvitationsTab from "./InvitationsTab";

export default function InvitationsPage() {
  const { user } = useAuth();
  const allowed = (user?.role === "admin" && !user?.impersonating) || user?.can_view_invitations || user?.invitations_can_send; // v3.4.410

  if (!allowed) {
    return <div style={{ padding: 40, textAlign: "center", color: "#b45309", fontSize: 14 }}>ليس لديك صلاحية إرسال الدعوات</div>;
  }

  return (
    <div style={{ padding: "24px 28px", direction: "rtl", fontFamily: "'Segoe UI', Tahoma, sans-serif" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <FiImage size={22} style={{ color: "#0f766e" }} />
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>الدعوات</h2>
        <span style={{ fontSize: 11, background: "#0f766e", color: "#fff", padding: "2px 10px", borderRadius: 12, fontWeight: 600 }}>
          كرت باسم كل مدعو
        </span>
      </div>
      <InvitationsTab user={user} />
    </div>
  );
}
